export default function useUI() {
  const adjustMainWrapperPosition = () => {
    const mainWrapper = document.getElementById("main-wrapper");
    const topNav = document.getElementById("top-nav"); // Make sure this matches your TopNavigation component's class

    if (mainWrapper && topNav) {
      const mainWrapperRect = mainWrapper.getBoundingClientRect();
      const topNavRect = topNav.getBoundingClientRect();

      // Check if there's an overlap
      if (mainWrapperRect.top < topNavRect.bottom) {
        const adjustment = topNavRect.bottom - mainWrapperRect.top;
        mainWrapper.style.marginTop = `${adjustment}px`;
      } else {
        mainWrapper.style.marginTop = '0';
      }
    }
  };

  const scrollTop = () => {
    const element = document.getElementById("main-wrapper");
    if (element) {
      element.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  // Function to dismiss keyboard on iOS devices before navigation
  const dismissKeyboard = () => {
    // Check if any element has focus
    const activeElement = document.activeElement as HTMLElement;

    if (activeElement && (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.tagName === 'SELECT'
    )) {
      // Blur the active element to dismiss the keyboard
      activeElement.blur();

      // For iOS, we need to ensure the keyboard is fully dismissed
      // by temporarily setting the element to readonly
      if (isIOS()) {
        activeElement.setAttribute('readonly', 'readonly');
        setTimeout(() => {
          activeElement.removeAttribute('readonly');
        }, 50);
      }

      // Return focus to the body to ensure keyboard is dismissed
      document.body.focus();
    }
  };

  // Helper function to detect iOS
  const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || '';
    return /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  };

  return { scrollTop, adjustMainWrapperPosition, dismissKeyboard };
}
